module.exports = "/_next/static/images/digital-ocean-avatar-50993dd83af3e6353be219b4f02cc0b7.png";